/**
 * 获取 App Version
 * @return {string} - app version
 */

import { bridge, xenv } from '@didi/webx-js'
export const getAppVersion = async () =>
  new Promise(resolve => {
    __mpx_mode__ === 'web' && ['passenger', 'hypassenger'].includes(xenv())
      ? /* cspell: disable-next-line */
        bridge.getSystemInfo({}, res => resolve(res.appversion))
      : resolve()
  })
